import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import type { FacilityID } from '../../../cross-app-shared/types/db';
import { slugFromName } from '../../../tri-shared/services/formatting';

export type Face = 'tri' | 'emissions' | 'tierii' | 'hazwaste';

export const face = computed((): Face => {
  if (window.location.origin.includes('emissions')) {
    return 'emissions';
  } else if (window.location.origin.includes('tierii')) {
    return 'tierii';
  } else if (window.location.origin.includes('hazwaste')) {
    return 'hazwaste';
  } else {
    return 'tri';
  }
});

export const appTitle = computed((): string => {
  if (face.value === 'tri') {
    return 'TRI';
  } else if (face.value === 'tierii') {
    return 'Tier II';
  } else if (face.value === 'hazwaste') {
    return 'Hazardous Waste';
  } else {
    return 'Emissions';
  }
});

/** The page a face treats as a facility's home, so links into "the app" stay on the current face. */
export function faceHomeRoute(
  face: Face,
  facility: { facilityID: FacilityID; name: string },
  year: number,
): RouteLocationRaw {
  const facilityParams = { facilityID: facility.facilityID, facilitySlug: slugFromName(facility.name) };
  switch (face) {
    case 'tri':
      return { name: 'Facility Status', params: { ...facilityParams, year: year.toString() } };
    case 'emissions':
      return { name: 'Emissions Units', params: { ...facilityParams, year: year.toString() } };
    case 'tierii':
      return { name: 'TierII Overview', params: facilityParams };
    case 'hazwaste':
      return { name: 'HazWaste Overview', params: facilityParams };
  }
}
